export const passFormResultsColorOptions = {
  purple: { background: '#5800AB', font: 'white', name: 'Purple' },
  red: { background: '#8b0a03', font: 'white', name: 'Red' },
  yellow: { background: '#faf3d1', font: '#112e51', name: 'Yellow' },
  green: { background: '#008817', font: 'white', name: 'Green' },
};
